/* ------------------------------------------------------------------
   FAQ accordion.

   The FAQ product tab pulls its content from the "Crowd Control FAQ"
   page via the theme's custom_page block, which outputs the page HTML
   verbatim: a flat run of <h2> headings each followed by paragraphs and
   lists. Twenty questions rendered flat is a wall of text.

   This wraps each heading and the content that follows it in a native
   <details>/<summary> pair, so the tab reads as a collapsed list.

   Why this is done in the theme rather than by rewriting the page:
   Shopify page content is NOT theme-scoped. Editing that page would
   change the live site immediately, not just this draft theme, and the
   page also has to stand on its own at /pages/crowd-control-faq.

   The hook is `.faq-section`, the wrapper div that already exists in the
   page's own HTML - precise enough that the Description tab, which also
   contains h2 headings, is never touched.

   Native <details> is used rather than custom JS toggling so that
   keyboard access, screen-reader semantics and in-page Find all keep
   working with no extra code.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  function build(root) {
    if (root.dataset.faqAccordion === 'done') return;
    root.dataset.faqAccordion = 'done';

    var nodes = Array.prototype.slice.call(root.children);
    var groups = [];
    var current = null;

    nodes.forEach(function (node) {
      if (node.tagName === 'H2') {
        current = { heading: node, body: [] };
        groups.push(current);
      } else if (current) {
        current.body.push(node);
      }
      // Anything before the first H2 is left exactly where it is.
    });

    if (!groups.length) return;

    groups.forEach(function (group) {
      var details = document.createElement('details');
      details.className = 'tcc-faq-item';

      var summary = document.createElement('summary');
      summary.className = 'tcc-faq-question';
      summary.textContent = group.heading.textContent.trim();

      details.appendChild(summary);

      var wrap = document.createElement('div');
      wrap.className = 'tcc-faq-answer';
      group.body.forEach(function (n) { wrap.appendChild(n); });
      details.appendChild(wrap);

      root.insertBefore(details, group.heading);
      group.heading.remove();
    });
  }

  function run() {
    document.querySelectorAll('.faq-section').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Tab panes and AJAX section renders can inject the markup after load,
  // so re-run when new nodes appear. Guarded by the data flag above.
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) { run(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
